import { combineReducers } from "redux";
import { CustomInputMappingState, customInputMappingReducer, initialCustomInputMappingState } from "./customInputMapping/customInputMappingRedcuer";
import { UsersState, usersReducer, initialUsersState } from "./users/usersReducer";
import { CloudfrontState, cloudfrontReducer, initialCloudfrontState } from "./cloudfront/cloudfrontReducer";
import { OpenCollectionsState, openCollectionsReducer, initialOpenCollectionsState } from "./openCollections/openCollectionsReducer";
import { LevelsState, levelsReducer, initialLevelsState } from "./levels";
import { LabelsState, labelsReducer, initialLabelsState } from "./labels";
import { activeUsersReducer, initialActiveUsersState } from "./users/activeUsersReducer";

export interface GlobalDataState {
    users: UsersState
    activeUsers: UsersState
    cloudfront: CloudfrontState
    openCollections: OpenCollectionsState
    customInputMappings: CustomInputMappingState
    levels: LevelsState
    labels: LabelsState
}

export const globalDataReducer = combineReducers<GlobalDataState>({
    users: usersReducer,
    activeUsers: activeUsersReducer,
    cloudfront: cloudfrontReducer,
    openCollections: openCollectionsReducer,
    customInputMappings: customInputMappingReducer,
    levels: levelsReducer,
    labels: labelsReducer,
})

export const initialGlobalDataState: GlobalDataState = {
    users: initialUsersState,
    activeUsers: initialActiveUsersState,
    cloudfront: initialCloudfrontState,
    openCollections: initialOpenCollectionsState,
    customInputMappings: initialCustomInputMappingState,
    levels: initialLevelsState,
    labels: initialLabelsState
}